import "../common.scss";
import { Link } from "react-router-dom";
import { useState } from "react";
import Header from "../header/header";

export default function NavigationBar() {
  const [drawerOpen, setDrawerOpen] = useState(false);

  const navItems = [
    "HOME",
    "DETAILS",
    "OUR STORY",
    "OUR PEOPLE",
    "",
    "GALLERY",
    "REGISTRY",
    "Q & A",
    "RSVP",
  ];

  const burgerIcon = {
    src: `${process.env.PUBLIC_URL}/images/icons/burger-menu.svg`,
    alt: "burger menu icon",
  };

  const closeX = {
    src: `${process.env.PUBLIC_URL}/images/common/close-x.svg`,
    alt: "close x icon",
  };

  const navLinks = navItems.map((item, i) => {
    let link = "/";
    if (item === "Q & A") link = "/q-and-a";
    else if (item && item !== "HOME")
      link = `/${item.toLowerCase().replace(/ & /g, "-").replace(/ /g, "-")}`;
    return { id: i + 1, href: link, label: item };
  });

  const toggleDrawer = () => setDrawerOpen(!drawerOpen);

  return (
    <div id="navigation" className="navigation">
      {/* Desktop nav */}
      <nav className="navigation-bar">
        <ul>
          {navLinks.map(({ id, href, label }) =>
            label === "" ? (
              <li key={id}>
                <Header />
              </li>
            ) : (
              <li key={id} className="cormorant-600 nav-links text-center">
                <Link to={href}>{label}</Link>
              </li>
            ),
          )}
        </ul>
      </nav>

      {/* Mobile burger */}
      <div className="navigation-burger">
        <div className="mobile-nav-header">
          <Header />
        </div>

        <button className="expand-nav" onClick={toggleDrawer}>
          <span className="text-medium cormorant-600 font-size-3">MENU</span>
          <img
            className="burger-icon"
            src={burgerIcon.src}
            alt={burgerIcon.alt}
            loading="lazy"
          />
        </button>
        {/* Drawer */}
        <div className={`mobile-nav-items ${drawerOpen ? "open" : ""}`}>
          <button className="close-drawer" onClick={toggleDrawer}>
            <img
              className="close-x"
              src={closeX.src}
              alt={closeX.alt}
              width="32"
              height="32"
              loading="lazy"
            />
          </button>
          <div className="drawer-header">
            <Header />
          </div>
          <ul>
            {navLinks
              .filter(({ label }) => label !== "")
              .map(({ id, href, label }) => (
                <li
                  key={id}
                  className="cormorant-500 mobile-nav-links text-center"
                >
                  <Link to={href} onClick={() => setDrawerOpen(false)}>
                    {label}
                  </Link>
                </li>
              ))}
          </ul>
        </div>

        {/* Overlay */}
        {drawerOpen && (
          <div className="mobile-overlay visible" onClick={toggleDrawer}></div>
        )}
      </div>
    </div>
  );
}
